import { Box, Input, Flex, Button, HStack } from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

export default function Dashboard() {
  const [projectId, setProjectId] = useState("");
  const history = useHistory();

  document.documentElement.dir = "ltr";

  const onChange = (e) => {
    setProjectId(e.target.value);
  };

  const onSubmitV1 = (e) => {
    e.preventDefault();
    history.push(`/project/${projectId}`);
  };

  const onSubmitV2 = (e) => {
    e.preventDefault();
    history.push(`/v2/project/${projectId}`);
  };

  return (
    <Box>
      <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
        <Card mx="auto" w="50%">
          <form onSubmit={onSubmitV1}>
            <Input
              onChange={onChange}
              placeholder="Enter project id"
              value={projectId}
            />
            <HStack mt={4} spacing={4}>
              <Button onClick={onSubmitV1} type="button">
                V1
              </Button>
              <Button onClick={onSubmitV2} type="button">
                V2
              </Button>
            </HStack>
          </form>
        </Card>
      </Flex>
    </Box>
  );
}
